import i18next from "i18next";

export function CustomDate(rawDate: string) {
  if (!rawDate) return "-------";

  const date = new Date(rawDate);
  const isArabic = i18next.language.startsWith("ar");
  const locale = isArabic ? "ar-EG" : "en-GB";

  const formattedDate = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short", // short month names (e.g., Oct / أكتوبر)
    year: "numeric",
    hour12: false,
  }).format(date);

  return formattedDate;
}
